import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import BlockAnchor from "./blocks/BlockAnchor";
import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockImageGrid from "./blocks/BlockImageGrid";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import BlockSliderSimple from "./blocks/BlockSliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSliderImageBackgroundText from "./blocks/BlockSliderImageBackgroundText";
import BlockSliderMultipleText from "./blocks/BlockSliderMultipleText";
import BlockWebinaires from "./blocks/BlockWebinaires";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();

	// Blocks
	new BlockAnchor();
	new BlockBanner();
	new BlockCollapse();
	new BlockImageGrid();
	new BlockMap();
	new BlockQuotes();
	new BlockSliderImageBackgroundText();
	new BlockSliderSimple();
	new BlockSliderMultiple();
	new BlockSliderMultipleText();
	new BlockWebinaires();
});

window.initMap = function () {
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};
